import { useCallback } from 'react';
import { isNullsy } from '~/_shared/utils/typeGuards';
import { getMatchupDataColumnName } from '~/store/matchupData/matchupData.helpers';
import { useMatchupDataSelector } from '~/store/matchupData/matchupData.selectors';
import { usePrimarySpreadsheetId } from '~/store/selectors/usePrimarySpreadsheetId';

export const useGetColumnName = () => {
  const spreadsheetId = usePrimarySpreadsheetId();
  const matchupData = useMatchupDataSelector();

  return useCallback((columnId: string) => {
    if (isNullsy(spreadsheetId)) {
      return;
    }

    return getMatchupDataColumnName(matchupData, { columnId, spreadsheetId }) ?? undefined;
  }, [matchupData, spreadsheetId]);
};
